import TransactionListPage from './list/TransactionListPage.vue';

const routes = [
  {
    path: '/history',
    name: 'history',
    component: TransactionListPage,
    meta: {
      title: 'Transaction',
      requiresAuth: true
    }
  }
];

export default routes;
